import {
  IconArticle,
  IconArticleFilled,
  IconBulb,
  IconBulbFilled,
  IconMail,
  IconMailFilled,
  IconMovie,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconStar,
  IconStarFilled,
  IconThumbUp,
  IconThumbUpFilled
} from '@tabler/icons-react';
import { NavigationEndpoint } from './types';

export const NavigationEndpointConfig = {
  [NavigationEndpoint.recordings]: {
    icon: IconMovie,
    filledIcon: IconMovie,
    label: 'Recording'
  },
  [NavigationEndpoint.clips]: {
    icon: IconPlayerPlay,
    filledIcon: IconPlayerPlayFilled,
    label: 'Clips'
  },
  [NavigationEndpoint.social]: {
    icon: IconThumbUp,
    filledIcon: IconThumbUpFilled,
    label: 'Social'
  },
  [NavigationEndpoint.blog]: {
    icon: IconArticle,
    filledIcon: IconArticleFilled,
    label: 'Blog'
  },
  [NavigationEndpoint.email]: {
    icon: IconMail,
    filledIcon: IconMailFilled,
    label: 'Email'
  },
  [NavigationEndpoint.takeaways]: {
    icon: IconStar,
    filledIcon: IconStarFilled,
    label: 'Takeaways'
  },
  [NavigationEndpoint.custom]: {
    icon: IconBulb,
    filledIcon: IconBulbFilled,
    label: 'Custom'
  }
};

export const NavigationEndpointOrder = [
  NavigationEndpoint.recordings,
  NavigationEndpoint.clips,
  NavigationEndpoint.social,
  NavigationEndpoint.blog,
  NavigationEndpoint.email,
  NavigationEndpoint.takeaways,
  NavigationEndpoint.custom
];

export const CLIP_POPOVER_ASSUME_INSIDE_CLASS_NAME = 'clip-pop-over-assume-inside';

// Right edge of the SessionDetail left nav sidebar (w-20 sidebar + gap + visual padding).
// Used to clamp fixed-position overlays so they stay clear of the sidebar.
export const SESSION_SIDEBAR_WIDTH_PX = 88;
